import React, {useState, Fragment} from 'react';
import {Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import classnames from 'classnames';
import PropTypes from "prop-types";
import IndicatorsTabRowsPaginated from "./IndicatorsTabRowsPaginated";
import {formatIocType} from "../../helpers";


const _ = require('lodash')


const IndicatorsTabPaginated = ({indicators, contentUid}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeIocType, setActiveIocType] = useState(Object.keys(indicators)[0]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveIocType(Object.keys(indicators)[tab])
    }
  };

  if (Object.keys(indicators).length === 0) {
    return <Fragment />
  }

  if (!activeIocType || !Object.keys(indicators).includes(activeIocType)) {
    setActiveIocType(Object.keys(indicators)[0])
  }

  return (
    <div className="tabs tabs--bordered-bottom">
      <div className="tabs__wrap">
        <Nav tabs>
          {
            _.keys(indicators).map((iocType, index) =>
              <NavItem key={iocType}>
                <NavLink
                  className={classnames({active: activeTab === index})}
                  onClick={() => toggleTab(index)}
                  key={iocType}
                >
                  {formatIocType(iocType)} ({indicators[iocType].total})
                </NavLink>
              </NavItem>
            )
          }
        </Nav>
        <TabContent activeTab={activeTab}>
          {
            _.keys(indicators).map((iocType, index) =>
              <TabPane tabId={index} key={index}>
                <IndicatorsTabRowsPaginated
                  indicators={indicators[activeIocType].data}
                  activeIocType={activeIocType}
                  contentUid={contentUid}
                  total={indicators[activeIocType].total}
                />
              </TabPane>
            )
          }
        </TabContent>
      </div>
    </div>
  )
}

IndicatorsTabPaginated.propTypes = {
  indicators: PropTypes.array.isRequired,
  contentUid: PropTypes.string.isRequired
}

export default IndicatorsTabPaginated;
